import axios from 'axios'
import React, { createContext, useState } from 'react'
import { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { navigate } from 'gatsby'
import 'react-toastify/dist/ReactToastify.css'

export const UserContext = createContext({})

export const UserProvider = ({ children }) => {
    const [token, setToken] = useState('')
    const [userData, setUserData] = useState()
    const [contactList, setContactList] = useState([])
    const [isLoggedIn, setIsLoggedIn] = useState(true)

    // update states when app refreshes the browser | components rerender

    useEffect(() => {
        setToken(sessionStorage.getItem('token') || '')
        if (!sessionStorage.getItem('token')) {
            setIsLoggedIn(false)
        }
        if (sessionStorage.getItem('contactlist')) {
            setContactList(
                JSON.parse(sessionStorage.getItem('contactlist')) || []
            )
        }
    }, [])

    // update session storage when value changes
    useEffect(() => {
        sessionStorage.setItem('token', token)
        if (token && token !== '') {
            setIsLoggedIn(true)
        }
    }, [token])

    useEffect(() => {
        if (contactList) {
            sessionStorage.setItem('contactlist', JSON.stringify(contactList))
        }
    }, [contactList])

    const loginUser = async (e, form, setLoading) => {
        e.preventDefault()
        console.log(form)

        if (!form.userId || !form.password) {
            setLoading(false)
            return toast.error('Please user credentials')
        }

        /*if (form.userId.length !== 10) {
            setLoading(false)
            return toast.error('Please provide a valid 10 digit phone number')
        }*/

        let formdata = new FormData()

        formdata.append('username', form.userId)
        formdata.append('password', form.password)
        // formdata.append("token", form.token);

        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/Authentication`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            console.log(response)
            if (
                response.data &&
                response.data ===
                    'A confirmation email has been sent. Please check your inbox or spam folder to locate it. Confirm your email so you can login.'
            ) {
                setLoading(false)
                return toast.error(response.data)
            }
            if (
                response.data &&
                (response.data === 'unknown error occured' ||
                    response.data ===
                        'A new email has been sent for confirmation' ||
                    response.data ===
                        'A confirmation email has been sent. Please check your inbox or spam folder to locate it. Confirm your email so you can login.')
            ) {
                setLoading(false)
                return toast.error(response.data)
            }
            // if (response.data && response.data !== "Password or username invalid!") {
            //   setToken(response.data);
            //   setIsLoggedIn(true);
            //   navigate("/app/BroadcastSMS");
            // }

            if (
                response.data &&
                response.data === 'Password or username invalid!'
            ) {
                setLoading(false)
                return toast.error(response.data)
            }
            if (response.error) {
                setLoading(false)
                throw new Error(response.error)
            }
            setToken(response.data)
            setIsLoggedIn(true)
            setLoading(false)
            navigate('/app/BroadcastSMS')
        } catch (err) {
            setLoading(false)
            toast.error('Invalid Credentials')
            console.log(err)
        }
    }

    const logout = function () {
        // sessionStorage.removeItem("token");
        // sessionStorage.removeItem("userdata");
        // sessionStorage.removeItem("loggedin");
        setToken('')
        setIsLoggedIn(false)
        setUserData()
    }
    const loadProfile = async function (setLoading) {
        try {
            const response = await axios.get(
                `${process.env.GATSBY_API_URL}/MyAccount`,

                {
                    headers: {
                        authorization: `Bearer ${token}`
                        // "Content-Type": "multipart/form-data",
                        // Connection: "keep-alive",
                    }
                }
            )
            console.log(response)
            if (response.data) {
                setUserData(response.data)
                setLoading(false)
            }
            if (response.error) {
                throw new Error(response.error)
            }
        } catch (err) {
            console.log(err)
            toast.error('Something went wrong')
        }
    }

    const createAccount = async (e, form, setLoading) => {
        e.preventDefault()

        if (form.userId.length !== 10) {
            setLoading(false)
            return toast.error('Please provide a valid 10 digit phone number')
        }

        let formdata = new FormData()
        // localStorage.setItem("userPhoneNo", form.userId);
        formdata.append('userid', form.userId)
        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/CreateAccount`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            console.log(response)
            if (response.data && response.data !== 'user already exists!') {
                setLoading(false)
                navigate(`/confirm-otp?userId=${form.userId}`)
            }
            if (response.data && response.data === 'user already exists!') {
                setLoading(false)
                toast.error(response.data)
            }
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }
    const confirmOTP = async (e, form, setLoading) => {
        e.preventDefault()
        if (form.otp.length < 6) {
            setLoading(false)
            return toast.error('Not a valid 6 digit OTP')
        }
        let formdata = new FormData()

        formdata.append('userid', form.userId)
        formdata.append('otp', form.otp)
        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/ConfirmOTP`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            console.log(response)
            if (response.data && response.data === 'Success') {
                setLoading(false)
                navigate(
                    `/account-details?userId=${form.userId}&otp=${form.otp}`
                )
            }
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }
    const signUp = async (e, form, setLoading) => {
        e.preventDefault()
        if (!form.termsAgreed) {
            setLoading(false)
            return toast.error('Please accept terms and conditions')
        }
        if (
            !form.senderId ||
            !form.contactName ||
            !form.organization ||
            !form.email ||
            !form.password
        ) {
            setLoading(false)
            return toast.error('Invalid form data')
        }
        if (form.senderId.length > 11) {
            setLoading(false)
            return toast.error('Sender ID can be 11 characters max')
        }
        let formdata = new FormData()

        formdata.append('userid', form.userId)
        formdata.append('otp', form.otp)
        formdata.append('password', form.password)
        formdata.append('senderid', form.senderId)
        formdata.append('name', form.contactName)
        formdata.append('organization', form.organization)
        formdata.append('email', form.email)

        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/SignUp`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            console.log(response)
            if (response.data && response.data.includes('success')) {
                // toast.success(
                //   "Your account has been created. A confirmation email has been sent. Please check your inbox or spam folder to locate it. Confirm your email so you can login."
                // );
                // setToken(response.data);
                // setIsLoggedIn(true);
                // navigate("/app/BroadcastSMS");
                setLoading(false)
                navigate('/signup-success')
            }
            if (response.data && !response.data.includes('success')) {
                setLoading(false)
                toast.error(response.data)
            }
            if (response.error) {
                setLoading(false)
                throw new Error(response.error)
            }
        } catch (err) {
            setLoading(false)
            console.log(err)
        }
    }

    const forgotPassword = async (e, form, setLoading) => {
        e.preventDefault()
        if (form.userId.length !== 10) {
            setLoading(false)
            return toast.error('Please provide a valid 10 digit phone number')
        }
        let formdata = new FormData()

        formdata.append('userid', form.userId)
        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/ForgotPassword`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            if (response.data && response.data === 'User does not exist.') {
                setLoading(false)
                return toast.error(response.data)
            }
            if (response.data) {
                console.log(response)
                setLoading(false)
                navigate(`/otp?userId=${form.userId}`)
            }
            if (response.error) {
                setLoading(false)
                throw new Error(response.error)
            }
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const passwordResetOtp = async (e, form, setLoading) => {
        e.preventDefault()
        if (form.otp.length < 6) {
            setLoading(false)
            return toast.error('Not a valid 6 digit OTP')
        }
        let formdata = new FormData()

        formdata.append('userid', form.userId)
        formdata.append('otp', form.otp)
        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/PasswordResetOTP`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            console.log(response)
            if (response.data && response.data === 'Failed') {
                setLoading(false)
                return toast.error('Invalid OTP')
            }
            if (response.data && response.data !== 'Failed') {
                // navigate(
                //   `/change-password?token=${response.data.split(":")[1].trim()}`
                // );
                setLoading(false)
                navigate('/otp-success')
            }
        } catch (error) {
            setLoading(false)
        }
    }

    const resetPassword = async (e, form, setLoading) => {
        e.preventDefault()
        console.log(form)
        if (form.newPassword !== form.confirmPassword) {
            setLoading(false)
            return toast.error('Password and Confirm Password must be same')
        }
        let formdata = new FormData()

        formdata.append('link', form.link)
        formdata.append('newpassword', form.newPassword)

        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/ResetPassword`,
                formdata,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        recaptcha: form.token
                    }
                }
            )
            console.log(response)
            if (
                response.data &&
                response.data === 'Password changed successfully!'
            ) {
                setLoading(false)
                navigate(`/change-password-success`)
            }
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    const sendContactMessage = async function (
        form,
        setForm,
        token,
        setLoading
    ) {
        if (!form.name || !form.contact || !form.email || !form.message) {
            setLoading(false)
            return toast.error('Please fill all fields')
        }
        if (form.contact.length !== 10) {
            setLoading(false)
            return toast.error('Please provide a valid 10 digit phone number')
        }
        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/ContactUs`,
                form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        recaptcha: token
                    }
                }
            )
            console.log(response)
            if (
                response.data &&
                response.data === 'Message sent successfully!'
            ) {
                setForm({
                    name: '',
                    contact: '',
                    email: '',
                    message: ''
                })
                setLoading(false)
                toast.success(response.data)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    const broadcastSMS = async function (
        message,
        setMessage,
        recaptchatoken,
        setLoading
    ) {
        try {
            const response = await axios.post(
                `${process.env.GATSBY_API_URL}/BroadcastSMS`,
                {
                    message,
                    listofnumbers: contactList.map((item) =>
                        item['Contact Number'].replaceAll(' ', '')
                    ),
                    names: contactList.map((item) => item['Name'])
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                        recaptcha: recaptchatoken
                    }
                }
            )
            console.log(response)
            if (response.data && response.data === 'Success!') {
                setLoading(false)
                setMessage('')
                setContactList([])
                toast.success(response.data)
            }
        } catch (error) {
            setLoading(false)
            toast.error('Something went wrong. Please try again')
            console.log(error)
        }
    }
    return (
        <UserContext.Provider
            value={{
                loginUser,
                setContactList,
                userData,
                setUserData,
                token,
                contactList,
                isLoggedIn,
                logout,
                createAccount,
                confirmOTP,
                signUp,
                forgotPassword,
                passwordResetOtp,
                resetPassword,
                sendContactMessage,
                broadcastSMS,
                loadProfile
            }}
        >
            {children}
            <ToastContainer theme="dark" position="bottom-left" />
        </UserContext.Provider>
    )
}
